import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ItemNumberToFilter } from 'src/app/components/auth/models/interface/itemNumberToFilter.interface';
import { MuFieldPositionEnum } from 'src/app/components/shared/models/interface/muFieldPosition.enum';
import { Actions } from 'src/app/components/shared/types/actions.type';
import { environment } from 'src/environments/environment';
import { AuthPersonBillingActions } from '../../auth-person-billing.actions';

@Component({
  selector: 'app-auth-person-billing-form',
  templateUrl: './auth-person-billing-form.component.html',
  styleUrls: ['./auth-person-billing-form.component.sass'],
})
export class AuthPersonBillingFormComponent implements OnInit {
  @Input() loader: boolean;
  @Input() formData: UntypedFormGroup;
  @Input() documentTypeList: ItemNumberToFilter[];
  @Input() cityList: ItemNumberToFilter[];
  @Input() showZipCode: boolean;
  @Input() actionList: Actions<AuthPersonBillingActions, any>;
  @Input() registerAction: AuthPersonBillingActions;
  fieldPositionEnum = MuFieldPositionEnum;

  constructor() {
    /** */
  }

/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
  ngOnInit(): void {
    /** */
  }
/* eslint-enable @angular-eslint/no-empty-lifecycle-method */

  /**
   * emit event register
   */
  register(): void {
    if (this.formData.get('isInvalidForm')?.value) {
      return environment.guardClause;
    }
    this.actionList?.emit(this.registerAction, null);
  }
}
